import { showNotification } from "@redotech/redo-web/alert";
import { Text } from "@redotech/redo-web/text";

const visible = { automations: false };

type NavigateToPath = (path: string) => void;
type RequestRateRefresh = (teamId: string) => void;

let requestRateRefreshHandler: RequestRateRefresh | undefined;

declare global {
  interface Window {
    __redoOpenOrderNavigate?: NavigateToPath;
  }
}

export function registerOpenOrderNavigate(
  navigate: NavigateToPath,
): () => void {
  window.__redoOpenOrderNavigate = navigate;
  return () => {
    if (window.__redoOpenOrderNavigate === navigate) {
      delete window.__redoOpenOrderNavigate;
    }
  };
}

export function registerRateRefreshRequest(
  request: RequestRateRefresh,
): () => void {
  requestRateRefreshHandler = request;
  return () => {
    if (requestRateRefreshHandler === request) {
      requestRateRefreshHandler = undefined;
    }
  };
}

/** Asks the mounted app to call the rate-refresh RPC. */
export function requestRateRefresh(teamId: string): void {
  requestRateRefreshHandler?.(teamId);
}

export function openOrderDashboardPath(teamId: string): string {
  return `/stores/${teamId}/shipping/outbound-labels/dashboard`;
}

function showOpenOrderNotification({
  teamId,
  kind,
  title,
  linkLabel,
}: {
  teamId: string;
  kind: keyof typeof visible;
  title: string;
  linkLabel: string;
}): void {
  if (visible[kind]) {
    return;
  }
  visible[kind] = true;
  showNotification({
    notificationKey: kind,
    onDismiss: () => {
      visible[kind] = false;
    },
    title,
    children: (dismiss) => (
      <Text fontSize="sm" textColor="secondary">
        This could take a few minutes to complete.{" "}
        <Text
          as="span"
          cursor="pointer"
          fontSize="sm"
          onClick={() => {
            const navigate = window.__redoOpenOrderNavigate;
            if (!navigate) {
              return;
            }
            navigate(openOrderDashboardPath(teamId));
            dismiss();
          }}
          textColor="secondary"
          textDecoration="underline"
        >
          {linkLabel}
        </Text>
      </Text>
    ),
  });
}

export function showRerunAutomationsNotification(teamId: string): void {
  showOpenOrderNotification({
    teamId,
    kind: "automations",
    title: "Rerunning automations...",
    linkLabel: "Click here to track automation progress",
  });
}
